<template>
	<transition name="list">
    <div class="popup-box popup-box-bg">
      <div class="position-relative" >
        <div class="row no-gutters justify-content-center">
          <div class="fixed-top d-block nav-bottom">
            <div class="custom-container-fluid px-0">
              <div class="row justify-content-center no-gutters">
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                  <div class="bg-white hide-scroll overflow-scroll">
                    <div class="w-100">
                      <div class="mt-12">
                        <div class="p-3 popup-box-bg">
                        	<div class="pop-up-warning bg-white box-shadow-1 rounded">
	                        	<div class="pt-3 pb-2 px-1 border-bottom">
	                        		<p class="text-center body-1-1 px-4 text-black mb-0">{{title}}</p>
	                        	</div>
	                        	<div class="w-100 p-4">
	                        		<div class="mb-3">
		                        		<label for="note" class="mb-0 bg-white body-2 text-12 font-regular">Note :</label>
	                        			<textarea
	                        				rows="3" 
	                        				id="note"  
		                              v-model="note" 
	                              	class="form-control mb-0 body-2-2 text-14" />
	                        		</div>
	                        		<div class="row slim-grid-row">
	                        			<div class="col-6">
		                        			<button class="button-black w-100" @click="cancel">
													          <p class="mb-0">
													            {{$t('hotel.action.cancel')}}
													          </p>
													        </button>
	                        			</div>
	                        			<div class="col-6">
		                        			<button class="button-primary w-100" @click="submit">
													          <p class="mb-0">
													            {{$t('hotel.action.submit')}}
													          </p>
													        </button>
	                        			</div>
	                        		</div>
	                        	</div>
	                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
	export default{
		props:{
			data:{
				type: String,
				default: ''
			},
			title:{
				type: String,
				default: ''
			}
		},
		data(){
			return{
				note: ''
			}
		},
		created(){
			this.note = this.data != '' ? this.data : ''
		},
		methods:{
			submit(){
				this.$emit('submit',this.note)
			},
			cancel(){
				this.$emit('cancel')
			}
		}
	}
</script>
<style scoped>
	.popup-box{
    position: fixed;
    height: 100vh;
    width: 100%;
    z-index: 9999;
    top: 0;
    left: 0;
    bottom: 0;
  }
  .popup-box-bg{
    background-color: rgba(0,0,0,.5)!important;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/PopupInputNote.vue